import { useNavigate } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <main
      data-testid="payment-cancel-page"
      className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-6"
    >
      <div className="max-w-lg text-center bg-white border border-[#EBEBEB] rounded-[2rem] p-12">
        <XCircle size={56} weight="light" className="text-[#6B705C] mx-auto" />
        <h1 className="font-display text-4xl text-[#2D3732] mt-6">Pago cancelado</h1>
        <p className="text-[#4A554E] mt-4 leading-relaxed font-light">
          No se ha realizado ningún cargo. Tu carrito sigue esperándote cuando quieras retomar la
          compra.
        </p>
        <button
          data-testid="cancel-home-btn"
          onClick={() => navigate("/")}
          className="mt-8 bg-[#A3B18A] hover:bg-[#8A9A6F] text-white rounded-full px-8 py-4 text-sm transition-colors"
        >
          Volver al inicio
        </button>
      </div>
    </main>
  );
}
